import React from 'react';
import { Checkbox } from 'antd';
import { CustomComponentProps, FieldOption } from '../types';

/**
 * Custom Checkbox wrapper component
 */
export interface MyCheckboxProps extends CustomComponentProps {
  options?: FieldOption[];
  children?: React.ReactNode;
}

const MyCheckbox: React.FC<MyCheckboxProps> = ({
  value,
  onChange,
  disabled,
  readonly,
  options,
  children,
  ...rest
}) => {
  const handleChange = (checkedValues: any) => {
    if (onChange) {
      onChange(checkedValues);
    }
  };

  const handleSingleChange = (e: any) => {
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  // If options are provided, render Checkbox.Group
  if (options && options.length > 0) {
    return (
      <Checkbox.Group
        value={value}
        onChange={handleChange}
        disabled={disabled || readonly}
        options={options}
        {...rest}
      />
    );
  }

  // Otherwise, render single Checkbox
  return (
    <Checkbox
      checked={value}
      onChange={handleSingleChange}
      disabled={disabled || readonly}
      {...rest}
    >
      {children}
    </Checkbox>
  );
};

export default MyCheckbox;
